export enum UserActions {
  DELETE = "delete",
  ACTIVATE_DEACTIVATE = "activate/deactivate",
}
